import React from 'react';
import {BaseComponent as Component} from 'BaseComponent';
import {LineupPlayerFinalHead} from '../../component/lineup-player-final-head';

class LineupDetails extends Component {
    render() {
        const {lineup} = this.props;

        return (
            <ul className="data-list">
                <li>
                    <strong>Proj:</strong> {lineup.totalAdminPoints}
                </li>
                <li>
                    <strong>FPts:</strong> {lineup.totalLineupPoints}
                </li>
                <LineupPlayerFinalHead lineup={lineup} />
                <li>
                    <strong>Total pOwn:</strong> {lineup.totalProjOwn}%
                </li>
            </ul>
        );
    }
}

export {LineupDetails};
